'use strict';

/*
    status表示稿件类型,0标识个人稿库,1表示已收稿库
 */
angular.module('iWoPersonalManuscriptRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.iWo.personalManuscript', {
            url: '/personalManuscript',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/personal_manuscript_tpl.html',
                    controller: 'iWopersonalManuscriptCtrl',
                },
            },
        }).state('iwonews', {
            url: '/iwonews?iwometadataid&iwochnldocid&iwoplatform',
            views: {
                '': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/news/news_tpl.html',
                    controller: 'iWoPersonalNewsController',
                },
            },
        }).state('iwoatlas', {
            url: '/iwoatlas?iwometadataid&iwochnldocid&iwoplatform',
            views: {
                '': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/atlas/atlas_tpl.html',
                    controller: 'iWoAtlasController',
                },
            },
        }).state('iwolinkdoc', {
            url: '/iwolinkdoc?iwometadataid&iwochnldocid&iwoplatform',
            views: {
                '': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/linkDoc/linkDoc_tpl.html',
                    controller: 'iWoLinkDocController',
                },
            },
        }).state('iwovideo', {
            url: '/iwovideo?iwometadataid&iwochnldocid&iwoplatform',
            views: {
                '': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/video/video_tpl.html',
                    controller: 'iWoVideoCtrl',
                },
            },
        }).state('iwobroadcasttvmanuscript', { // reportid：报题id
            url: '/iwobroadcasttvmanuscript?isfromplannedorder&iwometadataid&iwochnldocid&iwoplatform&seriesdocid&trench&siteid&tvplatform&sourceid&reportid&taskid',
            views: {
                '': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/broadcastTvManuscript/broadcastTvManuscript_tpl.html',
                    controller: 'iWoBroadcastTvManuscriptCtrl',
                },
            },
        }).state('iwoplannedorder', {
            url: '/iwoplannedorder?iwometadataid&iwochnldocid&iwoplatform',
            views: {
                '': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/plannedOrder/plannedOrder_tpl.html',
                    controller: 'iWoPlannedOrderCtrl',
                },
            },
        }).state('iwoplannedorderedit', {
            url: '/iwoplannedorderedit?iwometadataid&iwochnldocid&iwoplatform',
            views: {
                '': {
                    templateUrl: './editingCenter/iWo/myManuscript/personalManuscript/plannedOrderEdit/plannedOrderEdit_tpl.html',
                    controller: 'iWoPlannedOrdeEditCtrl',
                },
            },
        });
    }, ]);
